var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrevojnost(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 154,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#trevojnost_svg__clip0_632_7047)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.992 106.272s-11.288 21.999-22.37 16.578c-11.084-5.42-23.573-32.76-23.573-32.76S6.993 96.015.87 83.001c-3.686-3.42-.92-6.977-.14-6.977-.02-2.344 3.105-2.12 4.511-1.308 1.406.816 7.601 5.549 11.349 3.536 4.473-2.892-2.25-3.092-4.238-5.808-.555-.757.03-1.857.939-1.78 1.874.151 3.873.367 5.629.58 3.257.391 6.317 1.82 8.78 4.096l5.187 4.789L50.72 99.05",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.992 106.272s-11.288 21.999-22.37 16.578c-11.084-5.42-23.573-32.76-23.573-32.76S6.993 96.015.87 83.001c-3.686-3.42-.92-6.977-.14-6.977-.02-2.344 3.105-2.12 4.511-1.308 1.406.816 7.601 5.549 11.349 3.536 4.473-2.892-2.25-3.092-4.238-5.808-.555-.757.03-1.857.939-1.78 1.874.151 3.873.367 5.629.58 3.257.391 6.317 1.82 8.78 4.096l5.187 4.789L50.72 99.05",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.178 131.916v7.777s-10.015 14.006-14.541 37.561c-4.527 23.552-8.054 154.602-8.054 154.602l32.83.072 6.405-147.277 8.141 147.309 34.537.076c5.218-152.601-14.302-189.07-14.302-189.07l-1.049-9.53-43.967-1.52z",
    fill: "#F8D763"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.849 7.423s20.007 14.034 14.34 42.017c16.141 18.011 1.129 34.325 1.129 34.325l-65.156-5.788s-15.548-19.36 5.515-32.693c-4.82-24.835 13.014-37.25 13.014-37.25l31.158-.611z",
    fill: "#333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M125.367 26.57c0 12.993-10.611 21.838-22.956 21.838-12.344 0-23.2-10.565-22.352-23.527.711-10.89 7.301-24.363 22.352-21.523 16.237-1.484 22.956 10.218 22.956 23.212z",
    fill: "#333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.117 80.056c10.556 0 19.113-9.007 19.113-20.118 0-11.111-8.557-20.119-19.113-20.119-10.557 0-19.114 9.008-19.114 20.119s8.557 20.118 19.114 20.118z",
    fill: "#333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.362 42.544s-7.127 13.238-4.192 20.735c2.934 7.5 12.576 4.412 14.252 11.913 1.676 7.501-18.023 9.266-18.023 9.266L78.829 66.81s9.269.884 10.922-3.308c1.654-4.193-.44-12.574-.44-12.574l15.928-22.943",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M112.362 42.544s-7.127 13.238-4.192 20.735c2.934 7.5 12.576 4.412 14.252 11.913 1.676 7.501-18.023 9.266-18.023 9.266L78.829 66.81s9.269.884 10.922-3.308c1.654-4.193-.44-12.574-.44-12.574l15.928-22.943",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.691 52.57s-6.651 4.296-11.915 2.988c-18.449-4.585-2.516-45.002-2.516-45.002h12.827l15.469 11.25",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.691 52.57s-6.651 4.296-11.915 2.988c-18.449-4.585-2.516-45.002-2.516-45.002h12.827l15.469 11.25",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M85.535 24.453s5.029-2.648 6.708 1.764c1.677 4.413-6.286 12.354-6.286 12.354l2.094 3.528",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M85.535 24.453s5.029-2.648 6.708 1.764c1.677 4.413-6.286 12.354-6.286 12.354l2.094 3.528",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M89.31 31.038s-1.947-3.276-5.45-.884l5.45.884z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M89.31 31.038s-1.947-3.276-5.45-.884",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M101.448 33.278s-2.695-4.272-6.708-1.324l6.708 1.324z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M101.448 33.278s-2.695-4.272-6.708-1.324",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M97.086 34.486c.088-.848-.308-1.588-.884-1.654-.576-.066-1.113.568-1.2 1.415-.088.848.308 1.588.883 1.654.576.066 1.114-.568 1.201-1.416zM86.583 32.682c.088-.847-.308-1.588-.884-1.654-.576-.065-1.113.568-1.2 1.416-.088.847.308 1.588.883 1.654.576.066 1.114-.568 1.201-1.416z",
    fill: "#333"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M129.992 331.107c3.352-101.89-11.011-179.505-11.011-179.505",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M85.535 14.112s7.852 18.39 23.458 16.786c-7.331-2.296-12.744-12.885-12.744-12.885s10.357 12.813 20.764 12.985c1.383-5.464 2.227-9.129 2.227-9.129L97.032 4.744 86.977 9.713l-1.442 4.391v.008z",
    fill: "#333"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M108.36 25.765l2.167 10.945 4.788-3.828 1.44-6.465-8.395-.652z",
    fill: "#333"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M108.533 34.362c2.296-3.804 7.989-5.3 10.92-3.34 2.93 1.96 3.447 6.633 1.147 10.437-2.295 3.805-6.567 4.809-9.498 2.849",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M108.533 34.362c2.296-3.804 7.989-5.3 10.92-3.34 2.93 1.96 3.447 6.633 1.147 10.437-2.295 3.805-6.567 4.809-9.498 2.849",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M110.069 38.57s3.352-6.615 7.126-2.203l-7.126 2.204z",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M110.069 38.57s3.352-6.615 7.126-2.203",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M112.584 42.103s2.934-3.62 2.516-6.884l-2.516 6.884z",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M112.584 42.103s2.934-3.62 2.516-6.884",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M86.69 65.223S95.599 77 104.75 74.196c7.099-2.176 8.114-6.129 8.114-6.129l7.529-.872c9.335-1.084 17.7 6.097 18.571 15.942l2.748 31.089-15.42 3.604-5.154 15.614s-27.16 11.19-43.966-1.52c-4.356-8.777-6.431-24.755-6.431-24.755l-20.087-8.554 13.778-26.871c3.637-7.093 11.619-10.37 18.859-7.745l3.394 1.228.004-.004z",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M72.17 95.095s-4.83 18.411 5.006 36.817M84.98 140.529s-2.155 20.047 7.389 29.908l9.593 161.519M105.604 140.529s1.501 9.717 9.52 11.073M90.43 148.093c1.029 0 1.862-1.692 1.862-3.78s-.833-3.78-1.862-3.78c-1.028 0-1.862 1.692-1.862 3.78s.834 3.78 1.862 3.78zM50.66 98.607l20.083 8.554",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.23 60.556a1.5 1.5 0 011.782 1.152c.359 1.676 3.327 14.792 10.558 29.69 7.245 14.926 18.669 31.432 35.837 40.165a1.5 1.5 0 11-1.36 2.674c-18.019-9.165-29.813-26.359-37.176-41.529-7.377-15.197-10.407-28.57-10.792-30.371a1.5 1.5 0 011.152-1.781z",
    fill: "#F8D763"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M106.836 126.62c6.974-4.725 6.995-17.765.047-29.125S88.65 80.755 81.677 85.48c-6.974 4.725-6.995 17.765-.047 29.126 6.947 11.36 18.233 16.739 25.206 12.014z",
    fill: "#F8D763"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M78.828 88.397s2.257-4.868 8.657-4.632M106.834 126.614s4.556-2.652 4.876-8.12",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M85.27 92.28l-.002.002c-.96.694-1.204 2.077-.544 3.087l15.586 23.87c.66 1.011 1.973 1.267 2.933.572l.003-.002c.96-.694 1.204-2.077.544-3.087l-15.586-23.87c-.66-1.01-1.973-1.267-2.933-.572z",
    fill: "#F8D763"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M86.69 94.06l15.632 24.334",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M102.703 118.203l.486 4.032c.103.84-.566 1.56-1.368 1.476-.76-.08-1.273-.848-1.091-1.628l1.004-4.256.965.376h.004z",
    fill: "#333"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M86.69 65.222s13.853 20.031 26.175 2.845M57.77 105.736l-7.047-6.685s8.673-21.19 14.439-29.232",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1.161 83.217s1.36-1.508 3.216 0c8.973 7.285 13.541-2.276 18.228 2.68",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1.161 83.217s1.36-1.508 3.216 0c8.973 7.285 13.541-2.276 18.228 2.68",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M-.542 79.553s1.574-1.733 4.135.84C8.895 85.718 14.19 83.14 14.19 83.14",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M-.542 79.553s1.574-1.733 4.135.84C8.895 85.718 14.19 83.14 14.19 83.14",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M.491 76.336s1.24-1.056 3.8 1.516C9.595 83.177 14.74 80.91 14.74 80.91",
    fill: "#fff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M.491 76.336s1.24-1.056 3.8 1.516C9.595 83.177 14.74 80.91 14.74 80.91",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M129.232 104.472l14.963-21.499 4.455-5.548c2.117-2.637 4.941-4.525 8.107-5.421a143.24 143.24 0 015.484-1.452c.886-.216 1.623.78 1.178 1.616-1.584 2.996-8.559 4.408-3.728 6.569 3.987 1.4 9.806-4.413 11.079-5.437 1.273-1.024 4.333-1.736 4.644.588.772-.12 4.014 2.965.848 6.921-4.215 13.83-25.875 11.262-25.875 11.262s-11.296 46.078-26.997 41.537c-12.607-3.644 5.842-29.136 5.842-29.136z",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M176.009 81.069s-1.559-1.28-3.182.504c-7.844 8.605-13.713-.136-17.646 5.5",
    fill: "#fff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M176.009 81.069s-1.559-1.28-3.182.504c-7.844 8.605-13.713-.136-17.646 5.5",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M177.18 77.177s-1.802-1.469-3.972 1.476c-4.492 6.093-10.091 4.376-10.091 4.376",
    fill: "#fff"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M177.18 77.177s-1.802-1.469-3.972 1.476c-4.492 6.093-10.091 4.376-10.091 4.376",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M175.702 74.16s-1.376-.852-3.546 2.092c-4.493 6.093-9.901 4.657-9.901 4.657",
    fill: "#fff"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M175.702 74.16s-1.376-.852-3.546 2.092c-4.493 6.093-9.901 4.657-9.901 4.657M116.553 104.572l2.098 13.822",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M93.018 48.832c-1.01 1.16-1.611.444-3.39.24-1.782-.204-2.64.348-3.059-.976-.596-1.892 1.555-3.248 3.344-3.156 2.094.104 4.314 2.508 3.105 3.896v-.004z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "trevojnost_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 44,
    width: 8,
    height: 6
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M93.014 48.832c-1.01 1.16-1.61.444-3.39.24-1.782-.204-2.64.348-3.059-.976-.596-1.892 1.555-3.248 3.345-3.156 2.094.104 4.313 2.508 3.104 3.896v-.004z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#trevojnost_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.394 53.46c1.8 0 3.257-1.535 3.257-3.428s-1.458-3.428-3.257-3.428c-1.798 0-3.256 1.535-3.256 3.428 0 1.894 1.458 3.428 3.256 3.428z",
    fill: "#333"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "trevojnost_svg__clip0_632_7047"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h167v154H0z"
  })))));
}
export default __webpack_public_path__ + "static/trevojnost.d462eeca.svg";
export { SvgTrevojnost as ReactComponent };